import { render, staticRenderFns } from "./social-learning-modal.vue?vue&type=template&id=467a2322&scoped=true"
import script from "./social-learning-modal.vue?vue&type=script&lang=js"
export * from "./social-learning-modal.vue?vue&type=script&lang=js"
import style0 from "./social-learning-modal.vue?vue&type=style&index=0&id=467a2322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a2322",
  null
  
)

export default component.exports